import styled from "styled-components";

import {Spinner} from "@chakra-ui/react";
import React from "react";
import {ChevronRight} from "lucide-react";
import Main from '../../components/main';
import {FixedTopBar} from '../../components/top_bar';
import NavLink from "../../components/nav_link";
import useFeedback from "../../utils/use_feedback";
import {useBottomBar} from "../../app_context";
import {useSaveFolders} from "../../api/save";
import {useStoreProfile} from "../../store";
import {themecolors} from "../../utils/themecolors";

const SaveFolder = styled.div``;
const SpinnerContainer = styled.div`
  text-align: center;
  padding: 48px 0;
`;
const FolderName = styled.div``;
const ItemCount = styled.div``;

const Saved = styled(({className}) => {
    const {feedbackCh} = useFeedback();
    const folders = useSaveFolders(feedbackCh);
    const {theme} = useStoreProfile();
    useBottomBar();
    return (
        <>
            <FixedTopBar title="Saved" back />
            <Main className={className}>
                {!folders &&
                <SpinnerContainer>
                    <Spinner
                        thickness='4px'
                        speed='0.65s'
                        emptyColor={theme === "dark" ? themecolors.dark_background_5 : themecolors.light_low_impact_text}
                        color={theme === "dark" ? themecolors.dark_background_2 : themecolors.pure_white}
                        size='lg'
                    />
                </SpinnerContainer>
                }
                {folders?.map((folder, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <NavLink key={index} href={`/saved/${folder.name}`}>
                        <SaveFolder>
                            <FolderName>{folder.name}</FolderName>
                            <ItemCount>({folder.count})</ItemCount>
                            <ChevronRight size={20} />
                        </SaveFolder>
                    </NavLink>
                ))}
            </Main>
        </>
    );
})`
  ${SaveFolder} {
    padding: 16px 24px;
    font-size: 15px;  
    display: flex;
    align-items: center;
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
  }
  ${FolderName} {
    font-weight: 500;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }
  ${ItemCount} {
    padding-left: 4px;
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${SaveFolder} svg {
    margin-left: auto;
  }
`;

export default Saved;
